import { formataNumeroComPontos } from "../format";

export const retornaNomeDoEstadoPelaUF = (value) => {
  const estadosHash = [
    { label: "Brasil", value: "all" },
    { label: "Acre", value: "AC" },
    { label: "Alagoas", value: "AL" },
    { label: "Amapá", value: "AP" },
    { label: "Amazonas", value: "AM" },
    { label: "Bahia", value: "BA" },
    { label: "Ceará", value: "CE" },
    { label: "Distrito Federal", value: "DF" },
    { label: "Espírito Santo", value: "ES" },
    { label: "Goiás", value: "GO" },
    { label: "Maranhão", value: "MA" },
    { label: "Mato Grosso", value: "MT" },
    { label: "Mato Grosso do Sul", value: "MS" },
    { label: "Minas Gerais", value: "MG" },
    { label: "Pará", value: "PA" },
    { label: "Paraíba", value: "PB" },
    { label: "Paraná", value: "PR" },
    { label: "Pernambuco", value: "PE" },
    { label: "Piauí", value: "PI" },
    { label: "Rio de Janeiro", value: "RJ" },
    { label: "Rio Grande do Norte", value: "RN" },
    { label: "Rio Grande do Sul", value: "RS" },
    { label: "Rondônia", value: "RO" },
    { label: "Roraima", value: "RR" },
    { label: "Santa Catarina", value: "SC" },
    { label: "São Paulo", value: "SP" },
    { label: "Sergipe", value: "SE" },
    { label: "Tocantins", value: "TO" },
  ];
  return estadosHash
    ? estadosHash.find((option) => option.value === value).label
    : "";
};

export function formatarDadosDosGraficosDeArea(json) {
  const data = json.descricao_dados;
  //json.data.dados.sort(sortByDate);
  data.total_geral = formataNumeroComPontos(
    parseInt(data.total_teste_posi_prof + data.total_geral_teste_posi)
  );
  data.total_geral_teste_posi = formataNumeroComPontos(
    data.total_geral_teste_posi
  );
  data.total_teste_posi_prof = formataNumeroComPontos(
    data.total_teste_posi_prof
  );
  data.media_teste_posi_prof_semana = formataNumeroComPontos(
    data.media_teste_posi_prof_semana
  );

  return json;
}

export function formatarDadosDaApresentacao(data) {
  const json = data;

  json.dados.total_casos_profissionais_saude = formataNumeroComPontos(
    json.dados.total_casos_profissionais_saude
  );
  json.dados.total_internacoes_profissionais_saude = formataNumeroComPontos(
    json.dados.total_internacoes_profissionais_saude
  );
  json.dados.total_obitos_profissionais_saude = formataNumeroComPontos(
    json.dados.total_obitos_profissionais_saude
  );
  return json;
}

export function formataData(data) {
  const dataSplit = data.split("/");
  let meses = [
    0,
    "Janeiro ",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];

  return meses[parseInt(dataSplit[0])] + " de " + dataSplit[1];
}
